import { authClient } from './client';
import extractErrorMessage from '../utils/extractErrorMessage';

const protocolApi = {
  getAll: async (
    page = 1,
    limit = 10,
    { subcategory, category, durationDays, weightRange, status, searchTerm } = {},
  ) => {
    try {
      const params = { page, limit };
      if (subcategory) params.subcategory = subcategory;
      if (category) params.category = category;
      if (durationDays) params.durationDays = durationDays;
      if (weightRange) params.weightRange = weightRange;
      if (status) params.status = status;
      if (searchTerm) params.searchTerm = searchTerm;
      return (await authClient.get('/protocols', { params })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  getCategories: async () => {
    try {
      return (await authClient.get('/protocols/categories')).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  // Categories and rank apply to every version and don't create a new one.
  // `{ categories?, rank?, subcategories? }` — lineage-wide, no new version.
  updatePlacement: async (id, placement) => {
    try {
      return (await authClient.patch(`/protocols/${id}/placement`, placement)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  getById: async (id) => {
    try {
      return (await authClient.get(`/protocols/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  getVersionHistory: async (id) => {
    try {
      return (await authClient.get(`/protocols/${id}/versions`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  create: async (payload) => {
    try {
      return (await authClient.post('/protocols', payload)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  createNewVersion: async (id, payload) => {
    try {
      return (await authClient.patch(`/protocols/${id}`, payload)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  setPublished: async (id, isPublished) => {
    try {
      return (await authClient.patch(`/protocols/${id}/publish`, { isPublished })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },
};

export default protocolApi;
